import React from 'react';
import ReportCodes from '../../../components/reports/ReportCodes';
import PageLineReport from '../../components/PageLineReport';

const AnzahlAktiverKunden = () => {
    return <PageLineReport title="Anzahl aktiver Kunden" reportCode={ReportCodes.NumberOfActiveCustomers} />;
};

export default AnzahlAktiverKunden;
